import { useEffect, useRef } from 'react';

export const useEffectOnce = (effect: () => any, dependencies?: Array<any>) => {
  const wasEffectCalled = useRef<boolean>(false);

  useEffect(() => {
    if (wasEffectCalled.current) {
      return;
    }
    wasEffectCalled.current = true;
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies ?? []);
};
